import { onMounted, onUnmounted, ref } from 'vue';

export function useOnClickOutsideHide() {
  const isSuggesterOpen = ref(false);
  const suggesterRef = ref();

  const closeSuggester = (ev: MouseEvent) => {
    const suggesterEl = suggesterRef.value;
    const clickedOutside = suggesterEl !== ev.target && suggesterEl && !suggesterEl.contains(ev.target as Node);

    if (isSuggesterOpen.value && clickedOutside) {
      isSuggesterOpen.value = false;
    }
  };

  onMounted(() => {
    window.addEventListener('click', closeSuggester);
  });

  onUnmounted(() => {
    window.removeEventListener('click', closeSuggester);
  });

  return {
    suggesterRef,
    isSuggesterOpen
  };
}
